export enum USER_QUIZ_LIFESTYLE {
  SEDENTARY = 'SEDENTARY',
  MODERATELY_ACTIVE = 'MODERATELY_ACTIVE',
  VERY_ACTIVE = 'VERY_ACTIVE',
}
